// BUG-194 / IMP-415: company.update 권한 필드 변경 가드 — FE 분기 SSoT helper.
//
// BE rayguard-api `company.update` 정책 미러 (src/handlers/company.js):
//   - org             : COMPANY_ALLOWED_FIELDS 미포함 → 비-su 는 sanitizer 가 제거.
//                       su 만 bypassWhitelist 로 통과 (SEC-027 / BUG-148).
//                       org 은 su 판정의 근간(su = companyInfo.org === 'HQ')이라 권한 상승 벡터다.
//   - parentCompanyId : 비-su 는 403 PARENT_COMPANY_ID_RESTRICTED (voucherTemplate 조상 조회가
//                       parentCompanyId 를 타므로 변조 시 타 조직 template 노출 — SEC 사유).
//
//   두 필드의 실효 정책은 동일하게 **su 전용**이며, 차단 방식만 다르다(무음 drop vs 403).
//   FE 는 그 차이를 사용자에게 노출할 필요가 없으므로 단일 목록으로 다룬다.
//
// 본 가드는 "편집 노출 후 저장만 실패" UX 를 차단하는 용도다 (IMP-407 선례).
// BE 가 fail-closed SSoT — FE 를 우회해도 실제 변경은 되지 않는다.
//
// user.update 의 tier 가드(lib/userPermissionGuard.js)와 달리 company 는 등급이 하나뿐이라
// tier 개념 없이 boolean 으로 충분하다. 등급이 늘어나면 그쪽 패턴으로 승격할 것.
//
// ⚠️ **적용 범위: company.update 전용. 생성(create) 화면에 쓰지 말 것** (PR #522 리뷰).
//    BE `company.create` 는 비-su 에게 두 필드를 모두 허용한다 —
//      - org             : HQ 값만 차단(`ORG_HQ_FORBIDDEN`), 그 외 org 는 허용
//      - parentCompanyId : writeScope 내(자기 subtree)면 허용, 밖이면 403
//    즉 update 정책을 create 에 적용하면 정당한 생성 워크플로를 막는 over-restrict 가 된다.
//    create 용 가드가 필요해지면 위 두 조건을 반영한 **별도 헬퍼**를 만들 것.

import { ORG_HQ } from '../config/appConstants';

/** su(HQ) 만 변경할 수 있는 company 필드 — **update 경로 기준**(create 는 §적용 범위 참조). */
export const SU_ONLY_COMPANY_UPDATE_FIELDS = ['org', 'parentCompanyId'];

/**
 * su 판정 — BE authcheck 의 런타임 계산(companyInfo.org === 'HQ')과 동일 규칙.
 * DB 의 su 필드가 아니라 소속 회사의 org 로 판정하며, adminType 은 보지 않는다.
 * companyInfo / org 결측은 fail-closed.
 *
 * @param {object|null|undefined} authuser
 * @returns {boolean}
 */
export const isCompanySuperUser = (authuser) => authuser?.companyInfo?.org === ORG_HQ;

/**
 * **company.update** 화면의 필드 편집 가능 여부. su 전용 필드가 아니면 항상 true 를 반환하므로,
 * 호출처에서 화면의 editable(잠금 해제) 상태와 AND 연산해야 한다.
 *
 * @param {string} fieldName
 * @param {object|null|undefined} authuser
 * @returns {boolean}
 */
export const isCompanyUpdateFieldEditable = (fieldName, authuser) => {
    if (!SU_ONLY_COMPANY_UPDATE_FIELDS.includes(fieldName)) return true;
    return isCompanySuperUser(authuser);
};
